import React, {
	useCallback, useMemo, useRef, useEffect
} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import {useWindowSize} from 'react-use';
import {useFilter} from './context/filterContext';
import {useCatalog} from './context/catalogContext';
import CatalogAlbumDetail from './CatalogAlbumDetail';
import {clearTracks, clearAlbum} from '../../store/reducers/catalogSlice';
import CatalogAlbumList from './CatalogAlbumList';
import styled from 'styled-components';

const StyledDiv = styled.div` 
    padding-bottom: 100px;
`;

const CatalogAlbums = () => {
	const ref = useRef();
	const dispatch = useDispatch();
	const {getFilters} = useFilter();
	const {albumId, setAlbum, getCurrentPageData} = useCatalog();
	const {height} = useWindowSize();
	const {albums, pageNav} = useSelector((state) => state.catalog);
	const filters = useMemo(() => {
		return {...getFilters()};
	}, [getFilters]);

	const backBtnHandler = () => {
		setAlbum(undefined);
		dispatch(clearTracks());
		dispatch(clearAlbum());
	};

	const getData = useCallback(() => {
		getCurrentPageData({
			filters,
			infinity: true,
			page: pageNav.curPage + 1,
		});
	}, [getCurrentPageData, filters, pageNav]);


	return (
		<div className="catalog__content catalog__content--albums">
			{
				albumId
					? <CatalogAlbumDetail onBack={backBtnHandler}/>
					: (
						<StyledDiv
							id="scrollableDiv"
							className="Catalog__content-scroll-container mt-4"
							style={{
								height: height - 340,
								overflow: 'auto',
								display: 'flex',
								flexDirection: 'column',
							}}
						>
								<InfiniteScroll
									ref={ref}
									dataLength={albums.length}
									next={getData}
									style={{
										display: 'flex',
										flexDirection: 'column',
									}}
									hasMore={pageNav.curPage !== pageNav.allPage}
									loader={<h3>Загрузка ...</h3>}
									scrollableTarget="scrollableDiv"
								>
									<CatalogAlbumList/>
								</InfiniteScroll>
							</StyledDiv>
					)

			}
		</div>
	);
};

export default CatalogAlbums;
